import React from 'react';

function ClaimListMobile(props) {
    return (
        <div></div>
    );
}

export default ClaimListMobile;